<template>
  <v-row align="start" class="row--35">
    <v-col lg="6" md="6" sm="12" cols="12" order="2" order-md="1">
      <div class="text-left section-title mb--50">
        <span class="subtitle">Let's Say Hi</span>
        <h2 class="heading-title">Contact With Us.</h2>
        <div class="im_address">
          <span>Call us directly:</span><a class="link im-hover" href="tel:+639765224513">(+63) 998 390 9576</a>
        </div>
        <div class="im_address mt--5">
          <span>Contact Email:</span><a class="link im-hover"
            href="mailto:admin@rad-softwares.com">admin@rad-softwares.com</a>
        </div>
      </div>
      <div class="form-wrapper">
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <form @submit.prevent="handleSubmit(() => onSubmit(reset))">
            <ValidationProvider name="name" rules="required" v-slot="{ errors }">
              <label>
                <input type="text" v-model="formData.name" placeholder="Your Name *" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
              <label>
                <input type="text" rules="required|email" v-model="formData.email" placeholder="Your email *" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="subject" rules="required" v-slot="{ errors }">
              <label>
                <input type="text" v-model="formData.subject" placeholder="Write a Subject" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="message" rules="required" v-slot="{ errors }">
              <label>
                <textarea v-model="formData.message" placeholder="Your Message"></textarea>
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <div class="">
              <Turnstile ref="turnstile" sitekey="0x4AAAAAABUBGrtnXb33Ypsz" size="normal" appearance="always" @verify="(x) => turnstileToken = x" />
            </div>

            <button class="btn-default" type="submit" :disabled="loading || !turnstileToken" :class="{ 'is-loading': loading }">
              <span v-if="loading">Sending...</span>
              <span v-else>Submit Now</span>
            </button>
          </form>
        </ValidationObserver>
      </div>
      <div v-if="successMessage" class="success-message" style="color: green; margin-top: 16px;">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="error-message" style="color: red; margin-top: 16px;">
        {{ errorMessage }}
      </div>
    </v-col>
    <v-col lg="6" md="6" sm="12" cols="12" order="1" order-md="2">
      <div class="thumbnail mb_md--40 mb_sm--40">
        <slot name="contact-img"></slot>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
import Turnstile from 'cfturnstile-vue2'
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Turnstile,
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      successMessage: "",
      errorMessage: "",
      loading: false,
      turnstile: null,
      turnstileToken: '',
    };
  },
  methods: {
    async resetTurnstile() {
      this.turnstileToken = '';
      if (window.turnstile) {
        window.turnstile.reset();
      }
    },
    async onSubmit(resetValidation) {
      if (!this.turnstileToken) {
        this.errorMessage = 'Please complete the CAPTCHA.';
        return;
      }
      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';
      try {
        const response = await fetch('https://rough-mouse-2a08.roldhandasalla0x19.workers.dev/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...this.formData, turnstileToken: this.turnstileToken })
        });
        const data = await response.json();
        if (data.success) {
          this.successMessage = 'Message sent successfully!';
          this.formData = { name: '', email: '', subject: '', message: '' };
          this.turnstileToken = '';
          if (typeof resetValidation === 'function') resetValidation();
        } else {
          this.successMessage = '';
          this.errorMessage = 'Failed to send message. Please try again later. Error : ' + data.error;
          this.turnstileToken = '';
        }
      } catch (error) {
        this.errorMessage = 'Failed to send message. Please try again later. Error : ' + error;
        this.turnstileToken = '';
      } finally {
        this.loading = false;
        this.resetTurnstile();
      }
    },
  },
};
</script>

<style lang="scss">
.form-wrapper label input,
.form-wrapper label textarea {
  margin-bottom: 0;
}

.form-wrapper label {
  margin-bottom: 20px;
}
</style>
